import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/context/I18nContext";
import { AlertTriangle, Check } from "lucide-react";

// Shows "assigned / required" for multi-worker Field Jobs (required > 1).
// Amber when understaffed ("Needs N more"), emerald when fully/over staffed.
export function StaffingBadge({ assigned = 0, required = 1, testid = "staffing" }) {
  const { t } = useI18n();
  const req = required || 1;
  if (req <= 1) return null;
  const need = req - assigned;
  const short = need > 0;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full border ${
        short ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-emerald-50 text-emerald-700 border-emerald-200"
      }`}
    >
      {short ? <AlertTriangle className="h-3 w-3" /> : <Check className="h-3 w-3" />}
      {assigned} / {req}
      {short && <span>· {t("stf.needs", "Needs")} {need} {t("stf.more", "more")}</span>}
    </span>
  );
}
